var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tooltip-demo"}},[_c('tooltip-default'),_c('tooltip-position'),_c('tooltip-delay'),_c('tooltip-color'),_c('tooltip-title')],1)}
var staticRenderFns = []

export { render, staticRenderFns }